import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default from 'react';
import BaseSwitch from '@mui/material/Switch';
import c from 'classnames';
import { switchStyles } from './styles.js';
import { SIZE_CLASSES } from './utils.js';

var _excluded = ["className", "size"];
var Switch = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = SIZE_CLASSES[size];
  return /*#__PURE__*/React__default.createElement(BaseSwitch, _extends({
    ref: ref,
    className: c(switchStyles, className),
    classes: classes,
    color: "default"
  }, rest));
});
var Switch$1 = /*#__PURE__*/React__default.memo(Switch);

export { Switch$1 as default };
//# sourceMappingURL=Switch.js.map
